import { render, staticRenderFns } from "./ContactListSideMenu.vue?vue&type=template&id=2861731b"
import script from "./ContactListSideMenu.vue?vue&type=script&lang=js"
export * from "./ContactListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2861731b')) {
      api.createRecord('2861731b', component.options)
    } else {
      api.reload('2861731b', component.options)
    }
    module.hot.accept("./ContactListSideMenu.vue?vue&type=template&id=2861731b", function () {
      api.rerender('2861731b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact/ContactListSideMenu.vue"
export default component.exports